export const creatOrderFirst = [
  {
    path: `/CreatOrderFirst`,
    name: `CreatOrderFirst`,
    redirect: `/CreatOrderFirst/first`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/CreatOrderFirst/first',
        name: 'CreatOrderFirst/first',
        component: () => import('@/views/creatorderfirst/CreatOrderFirst')
      }
    ]
  }
];
